import React, { useEffect, useState } from 'react'
import { PieChart } from 'react-minimal-pie-chart';


export default function ProgressBar({ data, label, color, total }) {

    const [_total, _setTotal] = useState(0)
    const [_data, _setData] = useState(0)

    const getTotal = () => {
        let sayi = 0
        total.map((d, i) => {
            return sayi = parseInt(sayi) + parseInt(d)
        })
        _setTotal(sayi)
    }

    const getData = () => {
        let sayi = 0
        data.map((d, i) => {
            return sayi = parseInt(sayi) + parseInt(d)
        })
        _setData(sayi)
    }

    useEffect(() => {
        getTotal()
        getData()

        return () => {

        }
    })


    return (
        <div className='row'>
            <div className='col-4' >
            <table className='table table-sm table-bordered'>
                <tbody>
                <tr style={{ fontSize: '12px' }} >
                        <td>Yapılan</td>
                        <td>{_data}</td>
                    </tr>
                    <tr style={{ fontSize: '12px' }} >
                        <td >Toplam</td>
                        <td >{_total}<br /></td>
                    </tr>
                   
                </tbody>
            </table>
            </div>
            <div className='col-8' >
            <PieChart
                data={[{ value: parseInt(_data * 100 / _total), color: '#E38627' }]}
                totalValue={100}
                style={{ width: '150px',height:'100px',marginTop:'10px' }}
                lineWidth={20}
                label={({ dataEntry }) => !dataEntry.value ? "%0":'%' + dataEntry.value}
                labelStyle={{
                    fontSize: '25px',
                    fontFamily: 'sans-serif',
                    fill: '#E38627',
                }}
                labelPosition={0}
            />
            </div>
       
          
        </div>
    )
}